<template>
  <BModal
    id="no-serial-form"
    ref="noSerialModal"
    :title="translatedLabel('formTitle', 'mymachine_NoSerialForm')"
    no-close-on-backdrop
    @hide="resetForm"
  >
    <div class="px-3 px-md-5">
      <p>{{ translate('formDescription', labels, 'mymachine_NoSerialForm') }}</p>
      <form @submit.prevent="onSubmit">
        <div class="d-flex justify-content-center">
          <BForm
            ref="formEl"
            class="maxw-18"
            target="_blank"
            :action="getRegion === 'EMEA' ? apiRef.endpoints.SALESFORCE_EMEA.NO_SERIAL_FORM : apiRef.endpoints.SALESFORCE_NA.NO_SERIAL_FORM"
            method="get"
            @submit.stop.prevent
          >
            <input
              v-if="getRegion === 'NA'"
              type="hidden"
              name="f_recordTypeId"
              value="012a0000001NZQqAAO"
            >
            <input
              type="hidden"
              name="f_Serial_Number__c"
              :value="getRegion === 'EMEA' && isAttachment ? '' : 'Unserialized'"
            >
            <input
              type="hidden"
              name="f_TSP_Tree_Title__c"
              value="NoSession"
            >
            <input
              type="hidden"
              name="f_TSP_Session_ID__c"
              value="NoSession"
            >
            <input
              v-if="getRegion === 'EMEA'"
              type="hidden"
              name="f_Attachment_Issue__c"
              :value="isAttachment ? 'Yes' : 'No' "
            >
            <input
              v-if="getRegion === 'EMEA'"
              type="hidden"
              name="f_Attachment_Serial_Number__c"
              :value="isAttachment ? 'Unserialized' : ''"
            >

            <BFormGroup
              id="product-type-group"
              :label="translatedLabel('productTypeLabel', 'mymachine_NoSerialForm')"
              label-for="product-type"
              aria-describedby="product-type-feedback"
            >
              <input
                v-if="getRegion !== 'EMEA' || !isAttachment"
                v-model="form.f_Product_Type__c"
                class="d-none"
                type="text"
                :name="getRegion === 'EMEA' ? 'f_Primary_Product_Type__c' : 'f_Product_Type__c'"
              >
              <BasicFilterItem
                id="product-type"
                ref="productTypeRef"
                class="wide dropdown m-0"
                :disabled="loading || products.length === 1"
                :title="selectedProductType"
                :class="{'is-placeholder': form.f_Product_Type__c === ''}"
              >
                <div class="p-1" />
                <div
                  v-for="(itm, i) in products"
                  :key="'products_item_' + i"
                  class="nav-item text-nowrap"
                  :class="{'disabled': isDisabledOption(itm)}"
                  @click="() => onProductSelect()"
                >
                  <BDropdownItem @click="selectField('f_Product_Type__c', itm)">{{ itm.label }}</BDropdownItem>
                </div>
              </BasicFilterItem>
              <BFormInvalidFeedback
                id="product-type-feedback"
                :state="form.f_Product_Type__c !== '' ? null : false"
              >
                <b-icon
                  icon="exclamation-triangle"
                  class="me-1"
                />{{ translate('productTypeInvalidFeedback', labels, 'mymachine_NoSerialForm') }}
              </BFormInvalidFeedback>
            </BFormGroup>

            <template v-if="(isValidProduct || displayTSForm) && form.f_Product_Type__c !== ''">
              <BFormGroup
                id="system-group"
                :label="translatedLabel('systemLabel', 'mymachine_NoSerialForm')"
                label-for="system"
                aria-describedby="system-feedback"
              >
                <input
                  v-model="form.f_Warranty_System__c"
                  class="d-none"
                  type="text"
                  :name="getRegion === 'EMEA' ? 'f_System__c' : 'f_Warranty_System__c'"
                >
                <BasicFilterItem
                  id="system"
                  ref="systemRef"
                  class="wide dropdown m-0"
                  :disabled="loading || products.length === 1"
                  :title="selectedSystem"
                  :class="{'is-invalid': submitted && !form.f_Warranty_System__c, 'is-placeholder': form.f_Warranty_System__c === '' }"
                >
                  <div class="p-1" />
                  <div
                    v-for="(itm, i) in systemOptions"
                    :key="'system_item_' + i"
                    class="nav-item text-nowrap"
                    :class="{'disabled': isDisabledOption(itm)}"
                    @click="() => { systemRef?.hideDropdown() }"
                  >
                    <BDropdownItem @click="selectField('f_Warranty_System__c', itm)">{{ itm.label }}</BDropdownItem>
                  </div>
                </BasicFilterItem>
                <BFormInvalidFeedback
                  id="system-feedback"
                  :state="submitted && !form.f_Warranty_System__c ? false : null"
                >
                  <b-icon
                    icon="exclamation-triangle"
                    class="me-1"
                  />{{ translate('systemInvalidFeedback', labels, 'mymachine_NoSerialForm') }}
                </BFormInvalidFeedback>
              </BFormGroup>

              <BFormGroup
                v-if="getRegion === 'NA'"
                id="sub-type-group"
                :label="translatedLabel('caseSubTypeLabel', 'mymachine_NoSerialForm')"
                label-for="sub-type"
                aria-describedby="sub-type-feedback"
              >
                <input
                  v-model="form.f_SubType__c"
                  class="d-none"
                  type="text"
                  name="f_SubType__c"
                >
                <BasicFilterItem
                  id="sub-type"
                  ref="caseSubTypeRef"
                  class="wide dropdown m-0"
                  :disabled="loading || products.length === 1"
                  :title="selectedSubType"
                  :class="{'is-invalid': submitted && !form.f_SubType__c, 'is-placeholder': form.f_SubType__c === '' }"
                >
                  <div class="p-1" />
                  <div
                    v-for="(itm, i) in caseSubType"
                    :key="'case_subtype_item_' + i"
                    class="nav-item text-nowrap"
                    :class="{'disabled': isDisabledOption(itm)}"
                    @click="() => { caseSubTypeRef?.hideDropdown() }"
                  >
                    <BDropdownItem @click="selectField('f_SubType__c', itm)">{{ itm }}</BDropdownItem>
                  </div>
                </BasicFilterItem>
                <BFormInvalidFeedback
                  id="sub-type-feedback"
                  :state="submitted && !form.f_SubType__c ? false : null"
                >
                  <b-icon
                    icon="exclamation-triangle"
                    class="me-1"
                  />{{ translate('caseSubTypeInvalidFeedback', labels, 'mymachine_NoSerialForm') }}
                </BFormInvalidFeedback>
              </BFormGroup>

              <BFormGroup
                id="product-hours-group"
                :label="translatedLabel('productHoursLabel', 'mymachine_NoSerialForm')"
                :description="translatedLabel('productHoursHint', 'mymachine_NoSerialForm')"
                label-for="productHours"
                aria-describedby="product-hours-feedback"
              >
                <input
                  id="productHours"
                  v-model="form.f_Hours__c"
                  class="form-control"
                  name="f_Hours__c"
                  :placeholder="translatedLabel('productHoursPlaceholder', 'mymachine_NoSerialForm')"
                  :class="{'is-invalid': submitted && (!form.f_Hours__c || !isInteger(form.f_Hours__c))}"
                  @keypress="isNumber($event)"
                >
                <BFormInvalidFeedback
                  id="product-hours-feedback"
                  :state="submitted && (!form.f_Hours__c || !isInteger(form.f_Hours__c)) ? false : null"
                >
                  <b-icon
                    icon="exclamation-triangle"
                    class="me-1"
                  />{{ translate('productHoursInvalidFeedback', labels, 'mymachine_NoSerialForm') }}
                </BFormInvalidFeedback>
              </BFormGroup>

              <BFormGroup id="confirmation-group">
                <BFormCheckbox
                  id="confirmation"
                  v-model="confirmation"
                  class="text-small zindex-0"
                  aria-describedby="confirmation-feedback"
                  :state="submitted && !confirmation ? false : null"
                >
                  {{ translate('acceptanceLabel', labels, 'mymachine_NoSerialForm') }}
                </BFormCheckbox>
                <BFormInvalidFeedback
                  id="terms_accepted-feedback"
                  :state="submitted && !confirmation ? false : null"
                >
                  <b-icon
                    icon="exclamation-triangle"
                    class="me-1"
                  />{{ translate('acceptanceInvalidFeedback', labels, 'mymachine_NoSerialForm') }}
                </BFormInvalidFeedback>
              </BFormGroup>
            </template>
          </BForm>
        </div>
        <div
          v-if="!isValidProduct && !displayTSForm && form.f_Product_Type__c !== ''"
          class="text-danger"
          @click="troubleshootingFormClickHandler($event)"
          v-html="translatedLabel('useTSMessage', 'mymachine_NoSerialForm')"
        />
      </form>
    </div>
    <template #footer>
      <div class="text-end d-flex flex-wrap d-md-block w-100">
        <BButton
          class="mt-2 order-2 col-12 col-md-auto"
          variant="link"
          :disabled="loading"
          @click="resetForm()"
        >
          {{ translate('resetFormButton', labels, 'shared_CommonFunctional') }}
        </BButton>
        <BButton
          class="mt-2 ms-md-3 order-1 col-12 col-md-auto"
          variant="outline-primary"
          @click="closeModal"
        >
          {{ translate('closeButton', labels, 'shared_CommonFunctional') }}
        </BButton>
        <BButton
          type="submit"
          :disabled="(!isValidProduct && !displayTSForm) || form.f_Product_Type__c === ''"
          variant="primary"
          class="mt-2 ms-md-3 order-0 col-12 col-md-auto d-inline-flex justify-content-center align-items-center"
          @click="onSubmit"
        >
          <BSpinner
            v-if="loading"
            small
            class="me-2"
          />{{ translate('submitButton', labels, 'mymachine_NoSerialForm') }}<b-icon
            icon="bobcaticon-create"
            class="small ms-1"
          />
        </BButton>
      </div>
    </template>
  </BModal>
</template>

<script setup lang="ts">
import {ref, reactive, computed, watch} from 'vue'
import {useStore} from 'vuex'
import BasicFilterItem from '@/components/ui/forms/BasicFilterItem.vue'
import api from '@/api'
import {useCommon} from '@/composables/useCommon'

const {labels, translate, translatedLabel} = useCommon()
const store = useStore()

withDefaults(defineProps<{
  disabled?: boolean
}>(), {
  disabled: false
})

const emit = defineEmits<{(e: 'open-generic-form'): void
}>()

function isDisabledOption(item: unknown): boolean {
  return typeof item === 'object' && item !== null && 'disabled' in item && !!(item as Record<string, unknown>).disabled
}

const noSerialModal = ref<any>(null)
const formEl = ref<HTMLFormElement | null>(null)
const productTypeRef = ref<any>(null)
const systemRef = ref<any>(null)
const caseSubTypeRef = ref<any>(null)

const apiRef = api
const confirmation = ref(false)
const submitted = ref(false)
const form = reactive<Record<string, string>>({
  f_Product_Type__c: '',
  f_Warranty_System__c: '',
  f_SubType__c: '',
  f_Hours__c: ''
})
const selected = reactive<Record<string, string>>({
  f_Product_Type__c: '',
  f_Warranty_System__c: ''
})
const _error = ref<Record<string, any>>({})
const loading = ref(false)
const displayTSForm = ref(false)

const getRegion = computed<string>(() => store.getters['mymachine/getRegion'])

const isAttachment = computed<boolean>(() => form.f_Product_Type__c === productsWithoutTSP.value[0])

const products = computed(() => {
  const values = labels.value?.['mymachine_NoSerialForm']?.productTypeValues?.split('\n').filter((el: string) => el !== '') || []
  return splitKeyValue(values)
})

const productsWithoutTSP = computed<string[]>(() => {
  return labels.value?.['mymachine_NoSerialForm']?.productTypeWithoutTSP?.split('\n').filter((el: string) => el !== '') || []
})

const systemOptions = computed(() => {
  const values = labels.value?.['mymachine_NoSerialForm']?.systemValues?.split('\n').filter((el: string) => el !== '') || []
  return splitKeyValue(values)
})

const caseSubType = computed<string[]>(() => {
  return labels.value?.['mymachine_NoSerialForm']?.caseSubTypeValues?.split('\n').filter((el: string) => el !== '') || []
})

const selectedProductType = computed<string>(() => selected.f_Product_Type__c || translatedLabel('productTypePlaceholder', 'mymachine_NoSerialForm'))

const selectedSystem = computed<string>(() => selected.f_Warranty_System__c || translatedLabel('systemPlaceholder', 'mymachine_NoSerialForm'))

const selectedSubType = computed<string>(() => form.f_SubType__c || translatedLabel('caseSubTypePlaceholder', 'mymachine_NoSerialForm'))

const isValidProduct = computed<boolean>(() => productsWithoutTSP.value.indexOf(form.f_Product_Type__c) !== -1 && getRegion.value !== 'NA')

watch(caseSubType, () => {
  prefillForm()
})

function isInteger(value: string): boolean {
  return /^\d+$/.test(value)
}

function troubleshootingFormClickHandler(event: Event): void {
  const target = event.target as HTMLElement
  const link = target.closest('#troubleshoot-notification')
  if (link) {
    displayTSForm.value = true
  }
  const troubleshootingModalLink = target.closest('#model-troubleshooting')
  if (troubleshootingModalLink) {
    displayTSForm.value = false
    closeModal()
    emit('open-generic-form')
  }
}

function isNumber(evt: KeyboardEvent): boolean | void {
  const charCode = evt.which ? evt.which : evt.keyCode
  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) evt.preventDefault()
  else return true
}

function splitKeyValue(conceptArray: string[]): { value: string; label: string }[] {
  return conceptArray.map((v: string) => {
    const keyValue = v.split('|')
    return {value: keyValue[0], label: keyValue[1] || keyValue[0]}
  })
}

function prefillForm(): void {
  if (caseSubType.value.length === 1) form.f_SubType__c = caseSubType.value[0]
}

function openModal(): void {
  noSerialModal.value?.show()
}

function selectField(f: string, i: any): void {
  form[f] = i.value || i
  selected[f] = i.label || i
}

function resetForm(): void {
  form.f_Product_Type__c = ''
  form.f_Warranty_System__c = ''
  form.f_SubType__c = ''
  form.f_Hours__c = ''
  selected.f_Product_Type__c = ''
  selected.f_Warranty_System__c = ''
  confirmation.value = false
  submitted.value = false
  prefillForm()
}

function validateForm(): boolean {
  if (!form.f_Warranty_System__c) return false
  if (getRegion.value === 'NA' && !form.f_SubType__c) return false
  if (!form.f_Hours__c || !isInteger(form.f_Hours__c)) return false
  if (!confirmation.value) return false
  return true
}

function sendForm(): void {
  if (formEl.value) {
    (formEl.value as any).$el?.submit?.() || (formEl.value as any).submit?.()
  }
  closeModal()
}

function onSubmit(): void {
  submitted.value = true
  if (validateForm()) {
    sendForm()
  }
}

function closeModal(): void {
  noSerialModal.value?.hide()
}

function onProductSelect(): void {
  productTypeRef.value?.hideDropdown()
  displayTSForm.value = false
}

// created lifecycle
prefillForm()

defineExpose({openModal})
</script>

<style lang="scss" scoped>

.form-control.is-invalid {
  background-image: none;
}

.maxw-18 {
  width: 100%;
  max-width: 18rem;
}
</style>
